import { useState } from 'react';

import { Button } from '@xing-com/button';
import { IconSearch, IconArrowRight } from '@xing-com/icons';
import { NotOnLarge, OnlyOnLarge } from '@xing-com/layout-primitives';

import { SearchSlot, InputBarSearch } from './components/shared-styles';
import { useSearchContext } from './search-provider';

export const SearchSlotSection: React.FC<{
  placeholder: string;
}> = ({ placeholder }) => {
  const { searchParams, setSearchParams } = useSearchContext();
  const query = searchParams.keywords ?? '';
  const [searchInput, setSearchInput] = useState(query);

  const onSubmit: React.FormEventHandler = (ev) => {
    ev.preventDefault();
    setSearchParams({ keywords: searchInput });
  };

  const onChange: React.FormEventHandler = (
    ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSearchInput(ev.target.value);
  };

  const onClearInput = (): void => {
    setSearchParams({ keywords: '' });
  };

  return (
    <>
      <NotOnLarge>
        <SearchSlot onSubmit={onSubmit} data-testid="search-slot-form">
          <InputBarSearch
            clearButtonProps={{ 'aria-label': 'Clear keywords input field' }}
            icon={IconSearch}
            id="search-input"
            size="medium"
            placeholder={placeholder}
            value={searchInput || ''}
            onChange={onChange}
            onClearInput={onClearInput}
            variant="plain"
          />
          <Button
            icon={IconArrowRight}
            size="medium"
            type="submit"
            variant="onColorStrong"
          />
        </SearchSlot>
      </NotOnLarge>
      <OnlyOnLarge>
        <SearchSlot onSubmit={onSubmit} data-testid="search-slot-form">
          <InputBarSearch
            clearButtonProps={{ 'aria-label': 'Clear keywords input field' }}
            onClearInput={onClearInput}
            icon={IconSearch}
            id="search-input"
            size="large"
            placeholder={placeholder}
            value={searchInput || ''}
            onChange={onChange}
            variant="plain"
          />
          <Button
            size="large"
            variant="onColorStrong"
            type="submit"
            icon={IconArrowRight}
          />
        </SearchSlot>
      </OnlyOnLarge>
    </>
  );
};
